import request from "../utils/request";
import setting from "./apiSetting";
var urls = 'http://' + setting.getip() + ":" + setting.getport() + "/api/";
var myfunction = {
  updateAccount: function updateAccount(data) {
    return request({
      url: urls + 'Account/ChangeAccount',
      method: 'post',
      data: data
    });
  },
  updatePawd: function updatePawd(data) {
    return request({
      url: urls + 'Account/ChangePassword',
      method: 'post',
      data: data
    });
  },
  getAccount: function getAccount(data) {
    return request({
      url: urls + 'Account/List',
      method: 'get',
      params: data
    });
  },
  getManagerByDept: function getManagerByDept(data) {
    return request({
      url: urls + 'Employee/Manage',
      method: 'get',
      params: data
    });
  },
  getDepartment: function getDepartment(data) {
    return request({
      url: urls + 'Department',
      method: 'get',
      params: data
    });
  },
  addDepartment: function addDepartment(data) {
    return request({
      url: urls + 'Department/Add',
      method: 'post',
      data: data
    });
  },
  updateDepartment: function updateDepartment(data) {
    return request({
      url: urls + 'Department/Update',
      method: 'post',
      data: data
    });
  },
  deleteDepartment: function deleteDepartment(data) {
    return request({
      url: urls + 'Department/Delete',
      method: 'post',
      data: data
    });
  },
  getAccountGroup: function getAccountGroup(data) {
    return request({
      url: urls + 'List/AccountGroup',
      method: 'get',
      params: data
    });
  },
  disabledAccount: function disabledAccount(params, data) {
    return request({
      url: urls + 'Account/Disabled',
      method: 'post',
      params: params,
      data: data
    });
  },
  getCompany: function getCompany(data) {
    return request({
      url: urls + 'Company',
      method: 'get',
      params: data
    });
  },
  deleteCompany: function deleteCompany(data) {
    return request({
      url: urls + 'Company/DeleteByIds',
      method: 'get',
      params: data
    });
  },
  addCompany: function addCompany(data) {
    return request({
      url: urls + 'Company/Add',
      method: 'post',
      data: data
    });
  },
  updateCompany: function updateCompany(params, data) {
    return request({
      url: urls + 'Company/Update',
      method: 'post',
      params: params,
      data: data
    });
  },
  getInspectTermialWithCompany: function getInspectTermialWithCompany(data) {
    return request({
      url: urls + 'InspectTermial/GetWithCompany',
      method: 'get',
      params: data
    });
  },
  getInspectTermial: function getInspectTermial(data) {
    return request({
      url: urls + 'InspectTermial',
      method: 'get',
      params: data
    });
  },
  deleteInspectTermial: function deleteInspectTermial(data) {
    return request({
      url: urls + 'InspectTermial/DeleteByIds',
      method: 'get',
      params: data
    });
  },
  addInspectTermial: function addInspectTermial(data) {
    return request({
      url: urls + 'InspectTermial/Add',
      method: 'post',
      data: data
    });
  },
  updateInspectTermial: function updateInspectTermial(params, data) {
    return request({
      url: urls + 'InspectTermial/Update',
      method: 'post',
      params: params,
      data: data
    });
  },
  getNotice: function getNotice(data) {
    return request({
      url: urls + 'Notice',
      method: 'get',
      params: data
    });
  },
  addNotice: function addNotice(data) {
    return request({
      url: urls + 'Notice/Add',
      method: 'post',
      data: data
    });
  },
  updateNotice: function updateNotice(data) {
    return request({
      url: urls + 'Notice/Update',
      method: 'post',
      data: data
    });
  },
  deleteNotice: function deleteNotice(data) {
    return request({
      url: urls + 'Notice/Delete',
      method: 'post',
      data: data
    });
  },
  sendNotice: function sendNotice(data) {
    return request({
      url: urls + 'Notice/Send',
      method: 'post',
      data: data
    });
  },
  getParamList: function getParamList(data, paramName) {
    return request({
      url: urls + 'List/' + paramName,
      method: 'get',
      params: data
    });
  },
  addParamList: function addParamList(data, paramName) {
    return request({
      url: urls + 'List/' + paramName + '/Add',
      method: 'post',
      data: data
    });
  },
  deleteParamList: function deleteParamList(data, paramName) {
    return request({
      url: urls + 'List/' + paramName + '/Delete',
      method: 'post',
      data: data
    });
  },
  getSystemTask: function getSystemTask(data) {
    return request({
      url: urls + 'SystemTask',
      method: 'get',
      params: data
    });
  },
  handleSystemTask: function handleSystemTask(data) {
    return request({
      url: urls + 'SystemTask/Handle',
      method: 'post',
      data: data
    });
  },
  getCodeRule: function getCodeRule(data) {
    return request({
      url: urls + 'CodeRule',
      method: 'get',
      params: data
    });
  },
  updateCodeRule: function updateCodeRule(params, data) {
    return request({
      url: urls + 'CodeRule/UpdateList',
      method: 'post',
      params: params,
      data: data
    });
  },
  getInspectSettings: function getInspectSettings(data) {
    return request({
      url: urls + 'InspectSettings',
      method: 'get',
      params: data
    });
  },
  updateInspectSettings: function updateInspectSettings(params, data) {
    return request({
      url: urls + 'InspectSettings/UpdateList',
      method: 'post',
      params: params,
      data: data
    });
  },
  getSystemLog: function getSystemLog(data) {
    return request({
      url: urls + 'SystemLogView',
      method: 'get',
      params: data
    });
  },
  getSystemLogType: function getSystemLogType(data) {
    return request({
      url: urls + 'SystemLogType',
      method: 'get',
      params: data
    });
  },
  getUpdateInfo: function getUpdateInfo(data) {
    return request({
      url: urls + 'UpdateInfoView',
      method: 'get',
      params: data
    });
  },
  updateInfo: function updateInfo(data) {
    return request({
      url: urls + 'UpdateInfo',
      method: 'post',
      data: data
    });
  },
  getAllAccount: function getAllAccount(data) {
    return request({
      url: urls + 'Account/AllList',
      method: 'get',
      params: data
    });
  },
  bindManage: function bindManage(params, data) {
    return request({
      url: urls + 'InspectModule/BindManage',
      method: 'post',
      params: params,
      data: data
    });
  },
  getBindList: function getBindList(data) {
    return request({
      url: urls + 'InspectModule/GetBindList',
      method: 'get',
      params: data
    });
  }
};
export default myfunction;